window.initToleranceModals = function() {
  const modals = document.querySelectorAll(".metals-product__table-modal");


    modals.forEach((modal) => {
      const productId = modal.id.split("-").pop(); // Extract product ID
      const closeButton = modal.querySelector(".metals-product__table-modal-close");

      // Open modal logic
      const openButton = document.getElementById(`open-tolerance-modal-${productId}`);
      if (openButton) {
        openButton.addEventListener("click", () => {
          modal.style.display = "flex";
        });
      }

      // Close modal logic
      closeButton.addEventListener("click", () => {
        modal.style.display = "none";
      });

      // Close modal when clicking outside content
      modal.addEventListener("click", (event) => {
        if (event.target === modal) {
          modal.style.display = "none";
        }
      });
    });
  };